export default __webpack_public_path__ + "static/media/candidatosfinalesdisney2026.0f9320a4.pdf";